export const SELECT_OFFICE = "SELECT_OFFICE";
